import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { CContainer, CSpinner } from '@coreui/react';
import AdminMobileMenuBar from 'routes/adminMobile/components/common/AdminMobileMenuBar';
import { mainBgColor } from '../constraints/AdminConst';

// 스타일 변수 정의
const containerStyle = {
    // padding: '0 1.5rem',
    backgroundColor: mainBgColor,
};

const AdminMobileLayout = () => {
    return (
        <div style={containerStyle}>
            {/* 메뉴바 */}
            <AdminMobileMenuBar />
            <div>
                <CContainer lg>
                    <Suspense fallback={<CSpinner color="primary" />}>
                        <Outlet />
                    </Suspense>
                </CContainer>
            </div>
        </div>
    );
};

export default AdminMobileLayout;
